export default __webpack_public_path__ + "static/media/204-saudi arabia.315cd082.svg";